import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class ProxyService {

  constructor(private http: HttpClient) { }

  /**
   * Proxy HttpGet
   * options.header gives options to customize the http request header
   * depending upon the request
   * @param url
   * @param postData
   * @param options
   */
  httpPost(url: string, postData, options?) {
    const dataToPost = postData instanceof FormData ? postData : JSON.stringify(postData);
    if (options && options.headers) {
        return this.http.post(url, dataToPost, { headers: options.headers, observe: 'response' });
    }
    return this.http.post(url, dataToPost, { observe: 'response' });
  }

  /**
   * Proxy HttpGet
   * options.header gives options to customize the http request header
   * @param url
   * @param data
   * @param options
   */
  httpGet(url: string, data: any = null, options?) {
    if (options && options.headers) {
        return this.http.get(url, { headers: options.headers, params: { data }, observe: 'response' });
    }
    return this.http.get(url, { params: { data }, observe: 'response' });
  }

  /**
   * Http delete
   * @param url
   * @param options
   */
  httpDelete(url: string, options) {

    const req = new HttpRequest('DELETE', url);
    // adding body to the request using req.clone
    const newReq = req.clone({ body: options });
    return this.http.request(newReq);

  }
  /**
   * Http Patch
   * @param url
   * @param patchData
   * @param patchInput
   */
  httpPatch(url: string, patchData, patchInput: string = null) {

    if (patchInput) {
      url = url + '/' + patchInput;
    }

    return this.http.patch(url, JSON.stringify(patchData), { observe: 'response' });
  }
  /**
   * Http Put
   * options.header gives options to customize the http request header
   * @param url
   * @param postData
   * @param options
   */
  httpPut(url: string, postData, options?) {
    if (options && options.headers) {
        return this.http.put(url, postData, { headers: options.headers });
    }
    return this.http.put(url, postData);
  }
}
